import List from '@pelckmans/elementis/components/list';
import { useContext } from 'react';
import type { SlideSet } from '../../../../api/slide-set';
import { ANALYTICS_EVENT_SUBLOCATIONS } from '../../../../constants/analyticsEvents';
import ModuleContext from '../../_contexts/ModuleContext';
import SlideSetListItem from '../../components/SlideSetItem';
import useSlideSets from '../../hooks/useSlideSets';
import SelectionContext from '../_contexts/SelectionContext';
import TableOfContentsContext from '../_contexts/TableOfContentsContext';
import MaterialListHeader from './MaterialListHeader';

type SlideSetListProps = {
  title: string;
};

export default function SlideSetList({ title }: SlideSetListProps) {
  const { slideSets, fetchSlideSets } = useSlideSets();

  const { selectedModule } = useContext(ModuleContext);
  const { showSelection, selectedSlideSets, addSlideSets, removeSlideSets } = useContext(SelectionContext);
  const { selectedNode } = useContext(TableOfContentsContext);

  if (!selectedModule) return null;

  const subLocationId = selectedModule.isExerciseModule
    ? ANALYTICS_EVENT_SUBLOCATIONS.PORTAAL_EXERCISE_MODULE_OTHER_MATERIAL
    : ANALYTICS_EVENT_SUBLOCATIONS.PORTAAL_MODULE_OTHER_MATERIAL;

  return (
    <List>
      <MaterialListHeader<SlideSet>
        title={title}
        showSelection={showSelection}
        selectedMaterial={selectedSlideSets}
        material={slideSets}
        addMaterial={addSlideSets}
        removeMaterial={removeSlideSets}
      />
      {slideSets.map(slideSet => (
        <SlideSetListItem
          key={`${slideSet.id}-${slideSet.versionId}`}
          node={selectedNode}
          module={selectedModule}
          slideSet={slideSet}
          canBePinned={true}
          subLocationId={subLocationId}
          refetch={fetchSlideSets}
          isShared={slideSet.shared}
        />
      ))}
    </List>
  );
}
